import { Link } from 'react-router-dom';

import { metaMagnetSvg } from '~/assets/images';

const Header = () => {
  return (
    <header className="policy-header">
      <div>
        <Link to="/">
          <img src={metaMagnetSvg} width="178" height="32" alt="" />
        </Link>
        <h1>Policies</h1>
      </div>
    </header>
  );
};

export default Header;
